import scoreTimelines from "./score-timelines.json" with { type: "json" };
import { nbaVisualFixtures } from "./nba-visual-fixtures.ts";
import { summerSources } from "./source-fixtures.ts";
const clock = (period, periodLabel, displayClock) => ({
    period,
    periodLabel,
    displayClock
});
export const summerLeagueScenario = {
    id: "1522600045",
    label: "Clippers at Lakers",
    shortLabel: "LAC · LAL",
    competition: "NBA 2K Summer League",
    venue: "Thomas & Mack Center · Las Vegas",
    scheduledAt: "2026-07-15T02:00:00Z",
    replayDurationMs: 180_000,
    periodLengthSeconds: 600,
    awayTeam: {
        id: "clippers",
        city: "LA",
        name: "Clippers",
        abbreviation: "LAC",
        color: "#C8102E",
        contrastColor: "#FFFFFF"
    },
    homeTeam: {
        id: "lakers",
        city: "Los Angeles",
        name: "Lakers",
        abbreviation: "LAL",
        color: "#552583",
        contrastColor: "#FDB927"
    },
    replayAnchors: [
        { replayAtMs: 0, period: 1, clockSeconds: 600 },
        { replayAtMs: 4_000, period: 1, clockSeconds: 600 },
        { replayAtMs: 40_000, period: 1, clockSeconds: 0 },
        { replayAtMs: 80_000, period: 2, clockSeconds: 0 },
        { replayAtMs: 96_000, period: 3, clockSeconds: 464 },
        { replayAtMs: 132_000, period: 3, clockSeconds: 0 },
        { replayAtMs: 180_000, period: 4, clockSeconds: 0 }
    ],
    scoreEvents: scoreTimelines.games["1522600045"].events,
    storyBeats: [
        { replayAtMs: 0, text: "The Clippers and Lakers are next in Las Vegas." },
        { replayAtMs: 4_000, text: "The LA rivalry tips off in Las Vegas." },
        { replayAtMs: 13_600, text: "Carr's first three gives the Lakers the early edge." },
        { replayAtMs: 25_780, text: "Mañon has scored 10 of the Lakers' first 13." },
        { replayAtMs: 40_000, text: "Mañon sets the early tone for the Lakers." },
        { replayAtMs: 50_600, text: "The Lakers' second unit is maintaining the pressure." },
        { replayAtMs: 66_867, text: "Thiero keeps finding room inside as the lead grows." },
        { replayAtMs: 80_000, text: "Carr and Kaluma give the Lakers separation." },
        {
            replayAtMs: 96_000,
            text: "The Clippers have cut a 16-point halftime gap to six."
        },
        { replayAtMs: 108_182, text: "Mañon's steal and Thiero's three-point play steady the Lakers." },
        { replayAtMs: 129_184, text: "Carr's and-one and deep three stretch the Lakers' answer." },
        {
            replayAtMs: 132_000,
            text: "A 27–10 answer restores total Lakers control."
        },
        { replayAtMs: 134_320, text: "Sanders reaches 18 as the Clippers keep competing." },
        { replayAtMs: 148_400, text: "Wagler attacks the rim despite the deficit." },
        { replayAtMs: 158_160, text: "Mañon adds another tough finish to reach 17." },
        { replayAtMs: 163_360, text: "Thiero attacks the rim as the Lakers close it out." },
        { replayAtMs: 174_400, text: "Carr's final three gives him a game-high 23." },
        { replayAtMs: 180_000, text: "The Lakers move to 3–0 in Summer League." }
    ],
    evidenceEvents: [
        {
            id: "pregame",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "10:00"),
            kind: "media",
            facts: ["The Clippers and Lakers were set to meet in Las Vegas Summer League."],
            sourceRefs: ["NBA game 1522600045", "Getty 2286091747"]
        },
        {
            id: "summer-schedule",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "10:00"),
            kind: "media",
            facts: ["The Lakers published the Summer League matchup and Prime Video tune-in card before tip."],
            sourceRefs: ["X 2077196451667726671"]
        },
        {
            id: "summer-game-context",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "10:00"),
            kind: "stat",
            facts: ["Thomas & Mack Center hosted the Clippers-Lakers Summer League game, carried on Prime Video."],
            sourceRefs: ["NBA game a93c55243c1a"]
        },
        {
            id: "summer-availability",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "10:00"),
            kind: "stat",
            facts: ["The game-time roster record listed Clippers player Cam Christie inactive because of injury."],
            sourceRefs: ["NBA roster a1302bee8df4"]
        },
        {
            id: "tip-off",
            replayAtMs: 4_000,
            clock: clock(1, "1st", "10:00"),
            kind: "media",
            facts: ["Clippers and Lakers tipped off in Las Vegas Summer League."],
            sourceRefs: ["NBA game 1522600045", "Storypilot suggested post"]
        },
        {
            id: "carr-opening-three",
            replayAtMs: 13_600,
            clock: clock(1, "1st", "7:20"),
            kind: "score",
            facts: ["Cameron Carr's first three gave the Lakers an 8–3 lead."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "manon-first-quarter",
            replayAtMs: 25_780,
            clock: clock(1, "1st", "3:57"),
            kind: "stat",
            facts: [
                "Chris Mañon's pull-up at 4:21 gave the Lakers the final lead change, and he scored 10 of their first 13 points."
            ],
            sourceRefs: ["NBA box score", "X 2077218449625866381"]
        },
        {
            id: "first-quarter-close",
            replayAtMs: 40_000,
            clock: clock(1, "End 1st", "0:00"),
            kind: "score",
            facts: ["The Lakers led 24–16 after the first quarter."],
            sourceRefs: ["NBA box score"]
        },
        {
            id: "summer-second-quarter-open",
            replayAtMs: 40_667,
            clock: clock(2, "2nd", "9:50"),
            kind: "score",
            facts: ["The Lakers opened the second quarter with a 24–16 lead."],
            sourceRefs: ["NBA play-by-play 96f5e15d24de"]
        },
        {
            id: "ross-second-unit",
            replayAtMs: 50_600,
            clock: clock(2, "2nd", "7:21"),
            kind: "score",
            facts: ["Jackson Ross' driving finger roll restored a 33–24 Lakers lead."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "thiero-first-half-pressure",
            replayAtMs: 66_867,
            clock: clock(2, "2nd", "3:17"),
            kind: "score",
            facts: ["Mañon found Adou Thiero for a layup that put the Lakers ahead 43–32."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "halftime-lead",
            replayAtMs: 80_000,
            clock: clock(2, "Halftime", "0:00"),
            kind: "score",
            facts: [
                "Lakers led 54–38.",
                "Cameron Carr and Arthur Kaluma had 11 points each.",
                "Kaluma's third three, assisted by Mañon with 44.5 seconds left, had pushed the lead to 20."
            ],
            sourceRefs: ["NBA box score", "Storypilot suggested post"]
        },
        {
            id: "summer-end-second",
            replayAtMs: 80_000,
            clock: clock(2, "End 2nd", "0:00"),
            kind: "score",
            facts: ["The Lakers won the second quarter 30–22 and led 54–38 at the horn."],
            sourceRefs: ["NBA box score 4fd780942478"]
        },
        {
            id: "clippers-rally",
            replayAtMs: 96_000,
            clock: clock(3, "3rd", "7:44"),
            kind: "run",
            facts: ["The Clippers cut the deficit from 16 points to six at 56–50."],
            sourceRefs: ["NBA play-by-play", "Storypilot article evidence"]
        },
        {
            id: "clippers-rally-social",
            replayAtMs: 103_000,
            clock: clock(3, "3rd", "6:13"),
            kind: "media",
            facts: ["The Clippers' official feed highlighted Kobe Sanders during the response; the Lakers' lead was 61–52."],
            sourceRefs: ["NBA play-by-play 96f5e15d24de", "X 2077233231204888610"]
        },
        {
            id: "carr-third-quarter-and-one",
            replayAtMs: 129_184,
            clock: clock(3, "3rd", "36.3"),
            kind: "run",
            facts: [
                "Cameron Carr completed a three-point play at 1:28, then hit a deep three with 36.3 seconds left to reach 19 and put the Lakers ahead 81–60."
            ],
            sourceRefs: ["NBA play-by-play 96f5e15d24de actions 436–448"]
        },
        {
            id: "lakers-answer",
            replayAtMs: 132_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "run",
            facts: ["The Lakers outscored the Clippers 27–10 after the rally to lead 83–60."],
            sourceRefs: ["NBA play-by-play", "Storypilot article evidence"]
        },
        {
            id: "summer-fourth-quarter-open",
            replayAtMs: 132_800,
            clock: clock(4, "4th", "9:50"),
            kind: "score",
            facts: ["The Lakers opened the fourth quarter ahead 84–60 after a full-clock score at the start of the period."],
            sourceRefs: ["NBA play-by-play 96f5e15d24de"]
        },
        {
            id: "thiero-and-one",
            replayAtMs: 108_182,
            clock: clock(3, "3rd", "5:07"),
            kind: "milestone",
            facts: [
                "Mañon's second steal ended a Clippers possession with the margin at nine; 29 seconds later Thiero finished through contact to push the Lakers ahead 64–52."
            ],
            sourceRefs: ["NBA play-by-play 96f5e15d24de actions 386–400"]
        },
        {
            id: "sanders-eighteen",
            replayAtMs: 134_320,
            clock: clock(4, "4th", "9:31"),
            kind: "stat",
            facts: ["Kobe Sanders' three gave him 18 points and made the score 84–63."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "wagler-and-one",
            replayAtMs: 148_400,
            clock: clock(4, "4th", "6:35"),
            kind: "milestone",
            facts: ["AJ Wagler completed a three-point play to reach 11 points and cut the Lakers' lead to 86–68."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "manon-seventeen",
            replayAtMs: 158_160,
            clock: clock(4, "4th", "4:33"),
            kind: "stat",
            facts: [
                "Chris Mañon's and-one gave him 17 points and put the Lakers ahead 92–70.",
                "He finished with 17 points, 11 rebounds including four offensive, two assists and two steals."
            ],
            sourceRefs: ["NBA play-by-play 96f5e15d24de", "NBA box score 4fd780942478"]
        },
        {
            id: "thiero-dunk",
            replayAtMs: 163_360,
            clock: clock(4, "4th", "3:28"),
            kind: "media",
            facts: ["Adou Thiero drove for a dunk to make it 94–75."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "carr-twenty-three",
            replayAtMs: 174_400,
            clock: clock(4, "4th", "1:10"),
            kind: "milestone",
            facts: ["Cameron Carr's final three gave him a game-high 23 points."],
            sourceRefs: ["NBA play-by-play", "NBA box score"]
        },
        {
            id: "final",
            replayAtMs: 180_000,
            clock: clock(4, "Final", "0:00"),
            kind: "final",
            facts: [
                "Lakers won 99–85.",
                "Lakers made 13 threes to the Clippers' five.",
                "Lakers recorded a 23–15 assist edge.",
                "Mañon finished with 17 points, 11 rebounds, two assists and two steals.",
                "Carr scored a game-high 23 with zero turnovers.",
                "Kaluma added 15 points on 4-of-7 shooting, four assists and a game-best plus-27.",
                "Sanders led the Clippers with 18 points and six rebounds."
            ],
            sourceRefs: [
                "NBA box score",
                "Storypilot Starting Five",
                "Storypilot article",
                "X 2077244705696542852"
            ]
        },
        {
            id: "summer-end-fourth",
            replayAtMs: 180_000,
            clock: clock(4, "End 4th", "0:00"),
            kind: "score",
            facts: ["The fourth-quarter horn confirmed the Lakers' 99–85 win."],
            sourceRefs: ["NBA box score 4fd780942478", "NBA play-by-play 96f5e15d24de"]
        }
    ],
    feedAssets: [
        {
            id: "game-open",
            revealAtMs: 0,
            kind: "welcome",
            evidenceIds: ["pregame"],
            presentation: {
                label: "Before tip",
                eyebrow: "Las Vegas · Coming up",
                headline: "LA meets under Las Vegas lights",
                body: "The Clippers and Lakers bring a familiar rivalry to a Summer League stage where every rotation minute matters.",
                image: "/media/getty/1522600045/2286091747.jpg",
                imageAlt: "Clippers rookies Baba Miller and Keaton Wagler pose together before Summer League.",
                mediaShape: "portrait",
                source: summerSources.opener
            }
        },
        {
            id: "summer-schedule-card",
            revealAtMs: 0,
            kind: "welcome",
            evidenceIds: ["summer-schedule"],
            presentation: {
                label: "Tonight",
                eyebrow: "Las Vegas · Prime Video",
                headline: "The rivalry has a start time",
                body: "Prime Video carries the Clippers–Lakers matchup from Las Vegas; the Lakers' card supplies the invitation.",
                image: "https://assets.usestorypilot.com/posts/nba/x/2026/07/15/x_2077196451667726671/img_0.jpg",
                imageAlt: "The Lakers' official Clippers versus Lakers Summer League tune-in card.",
                mediaShape: "portrait",
                source: summerSources.scheduleX,
                accent: "#FDB927"
            }
        },
        {
            id: "summer-broadcast-context",
            revealAtMs: 0,
            kind: "insight",
            evidenceIds: ["summer-game-context"],
            presentation: {
                label: "Game guide",
                eyebrow: "Thomas & Mack Center · Las Vegas",
                headline: "Forty minutes to earn a look",
                body: "Four ten-minute quarters, two LA teams and a stage where unfamiliar names can make themselves difficult to ignore.",
                stats: [
                    { value: "LAC", label: "AWAY" },
                    { value: "LAL", label: "HOME" },
                    { value: "10 MIN", label: "QUARTERS" }
                ]
            }
        },
        {
            id: "summer-roster-note",
            revealAtMs: 0,
            kind: "alert",
            evidenceIds: ["summer-availability"],
            presentation: {
                label: "Before tip",
                eyebrow: "Game-time roster record",
                headline: "Christie is unavailable tonight",
                body: "Cam Christie is listed inactive through injury. The Clippers enter the matchup without him.",
                accent: "#C8102E"
            }
        },
        {
            id: "tip-off-live",
            revealAtMs: 4_000,
            kind: "welcome",
            evidenceIds: ["tip-off"],
            presentation: {
                label: "Game on",
                eyebrow: "1st · 10:00",
                headline: "LA tips off in Las Vegas",
                body: "The ball is up at Thomas & Mack Center. Four ten-minute quarters begin now."
            }
        },
        {
            id: "carr-opening-read",
            revealAtMs: 13_600,
            kind: "insight",
            evidenceIds: ["carr-opening-three"],
            presentation: {
                label: "Early read",
                eyebrow: "7:20 · 1st",
                headline: "Carr makes the space count",
                body: "Thiero draws the defense and Carr buries the kick-out. Both Lakers makes have come from deep, and the early edge is 8–3.",
                accent: "#FDB927"
            }
        },
        {
            id: "first-quarter-manon",
            revealAtMs: 25_780,
            kind: "insight",
            evidenceIds: ["manon-first-quarter"],
            presentation: {
                label: "Player watch",
                eyebrow: "3:57 · 1st",
                headline: "Mañon owns the opening",
                body: "His pull-up produces the game's final lead change; his next score makes it 10 of the Lakers' first 13 points. The opening belongs to Mañon.",
                image: "/media/social/x/2077218449625866381.jpg",
                imageAlt: "Chris Mañon scores during his fast start against the Clippers.",
                video: "/media/social/x/2077218449625866381.mp4",
                videoPoster: "/media/social/x/2077218449625866381.jpg",
                mediaShape: "landscape",
                source: summerSources.manonX,
                accent: "#FDB927",
                stats: [
                    { value: "10", label: "PTS" },
                    { value: "13", label: "LAL PTS" },
                    { value: "77%", label: "OF TOTAL" }
                ],
                actionLabel: "Watch the run",
                durationLabel: "0:14"
            }
        },
        {
            id: "first-quarter-score",
            revealAtMs: 40_000,
            kind: "insight",
            evidenceIds: ["first-quarter-close"],
            presentation: {
                label: "End of 1st",
                eyebrow: "End 1st · Lakers 24–16",
                headline: "Mañon sets the first-quarter terms",
                body: "Ten points from Mañon and four Lakers threes turn the opening exchange into a 24–16 lead after ten minutes.",
                accent: "#FDB927"
            }
        },
        {
            id: "summer-second-quarter-live",
            revealAtMs: 40_667,
            kind: "welcome",
            evidenceIds: ["summer-second-quarter-open"],
            presentation: {
                label: "2nd quarter",
                eyebrow: "9:50 · Lakers 24–16",
                headline: "Can the Clippers change the rhythm?",
                body: "The Lakers carry an eight-point cushion and Mañon's opening burst into the second quarter.",
                accent: "#FDB927"
            }
        },
        {
            id: "ross-keeps-the-pace",
            revealAtMs: 50_600,
            kind: "moment",
            evidenceIds: ["ross-second-unit"],
            presentation: {
                label: "Second unit",
                eyebrow: "7:21 · 2nd",
                headline: "Ross keeps the second unit downhill",
                body: "The finger roll restores a nine-point lead. The names have changed, but the Lakers are still getting downhill.",
                accent: "#FDB927"
            }
        },
        {
            id: "thiero-keeps-attacking",
            revealAtMs: 66_867,
            kind: "insight",
            evidenceIds: ["thiero-first-half-pressure"],
            presentation: {
                label: "Pressure point",
                eyebrow: "3:17 · 2nd",
                headline: "Thiero keeps attacking the seam",
                body: "Mañon finds the cut, Thiero finishes and the lead reaches 11. The Lakers are turning every gap into paint pressure.",
                accent: "#FDB927"
            }
        },
        {
            id: "halftime-catch-up",
            revealAtMs: 80_000,
            kind: "catch-up",
            evidenceIds: ["halftime-lead"],
            presentation: {
                label: "Halftime",
                eyebrow: "Halftime · Lakers 54–38",
                headline: "Carr and Kaluma stretch the half",
                body: "Carr and Kaluma have 11 each. Kaluma's third three—created by Mañon—pushed the lead to 20 before the Clippers trimmed it to 16 at the break.",
                image: "/media/summer-league/cameron-carr-portrait.jpg",
                imageAlt: "Cameron Carr smiles with the ball on court during Summer League.",
                caption: "The game in one glance"
            }
        },
        {
            id: "summer-second-quarter-score",
            revealAtMs: 80_000,
            kind: "insight",
            evidenceIds: ["summer-end-second"],
            presentation: {
                label: "End of 2nd",
                eyebrow: "Lakers 54 · Clippers 38",
                headline: "Thirty more points, sixteen clear",
                body: "The Lakers win the second quarter 30–22 and lead 54–38. Their first-quarter edge has become full control.",
                accent: "#FDB927",
                stats: [
                    { value: "30–22", label: "2ND QUARTER" },
                    { value: "+16", label: "HALFTIME" },
                    { value: "54", label: "LAL PTS" }
                ]
            }
        },
        {
            id: "clippers-push",
            revealAtMs: 96_000,
            kind: "alert",
            evidenceIds: ["clippers-rally"],
            presentation: {
                label: "Game alert",
                eyebrow: "7:44 · 3rd",
                headline: "Six-point game. The Clippers are back.",
                body: "A 12–2 burst has erased most of the halftime gap and forced the Lakers to answer.",
                accent: "#C8102E"
            }
        },
        {
            id: "clippers-rally-post",
            revealAtMs: 103_000,
            kind: "highlight",
            evidenceIds: ["clippers-rally-social"],
            presentation: {
                label: "From the Clippers",
                eyebrow: "6:13 · 3rd · Lakers 61–52",
                headline: "Sanders fronts the Clippers' response",
                body: "Kobe Sanders stands at the centre of the Clippers' push. A 16-point halftime gap is down to nine, and the game has changed temperature.",
                video: "https://assets.usestorypilot.com/posts/nba/x/2026/07/15/x_2077233231204888610/vid_0.mp4",
                imageAlt: "Kobe Sanders leads the Clippers' third-quarter response against the Lakers.",
                mediaShape: "landscape",
                source: summerSources.clippersRallyX,
                accent: "#C8102E",
                actionLabel: "Watch the Clippers' response"
            }
        },
        {
            id: "carr-stretches-the-answer",
            revealAtMs: 129_184,
            kind: "moment",
            evidenceIds: ["carr-third-quarter-and-one"],
            presentation: {
                label: "Scoring burst",
                eyebrow: "36.3 · 3rd · Lakers 81–60",
                headline: "Carr turns the answer emphatic",
                body: "First the finish through contact; then a deep three to reach 19. Carr stretches the Lakers' response at both the rim and the arc.",
                accent: "#FDB927",
                storyteller: {
                    type: "clip",
                    clipId: "c7a58983-b52d-5b00-45aa-3a227604b741",
                    accessibleLabel: "Play Cameron Carr's third-quarter and-one"
                }
            }
        },
        {
            id: "answering-run",
            revealAtMs: 132_000,
            kind: "moment",
            evidenceIds: ["lakers-answer"],
            presentation: {
                label: "End of 3rd",
                eyebrow: "End 3rd · Lakers 83–60",
                headline: "The Lakers answer with 27–10",
                body: "The Clippers got within six. The Lakers responded 27–10, with Carr, Mañon, Thiero and Kaluma all shaping the surge.",
                image: "/media/summer-league/arthur-kaluma-jumper.jpg",
                imageAlt: "Arthur Kaluma rises for a jump shot over a Clippers defender.",
                caption: "The defining response of the night",
                accent: "#FDB927"
            }
        },
        {
            id: "thiero-contact-finish",
            revealAtMs: 108_182,
            kind: "moment",
            evidenceIds: ["thiero-and-one"],
            presentation: {
                label: "Momentum play",
                eyebrow: "5:07 · 3rd",
                headline: "Thiero absorbs the hit—and finishes",
                body: "Mañon steals the Clippers' next chance with the margin at nine. Thiero cuts hard 29 seconds later, absorbs contact and restores a 12-point lead.",
                accent: "#FDB927",
                storyteller: {
                    type: "clip",
                    clipId: "2fa64299-a155-3234-a281-3a2275fda82b",
                    accessibleLabel: "Play Adou Thiero's finish through contact"
                }
            }
        },
        {
            id: "summer-fourth-quarter-live",
            revealAtMs: 132_800,
            kind: "welcome",
            evidenceIds: ["summer-fourth-quarter-open"],
            presentation: {
                label: "4th quarter",
                eyebrow: "9:50 · Lakers 84–60",
                headline: "The Lakers close the window",
                body: "A six-point scare became a 23-point lead. Ten minutes now separate the Lakers from a 3–0 start.",
                accent: "#FDB927"
            }
        },
        {
            id: "sanders-keeps-firing",
            revealAtMs: 134_320,
            kind: "insight",
            evidenceIds: ["sanders-eighteen"],
            presentation: {
                label: "Player watch",
                eyebrow: "9:31 · 4th",
                headline: "Sanders reaches 18 in reply",
                body: "His third three takes him to 18. Even with the margin at 21, the Clippers' leading scorer keeps pressing.",
                accent: "#C8102E",
                storyteller: {
                    type: "clip",
                    clipId: "55825751-c18b-bb15-cacc-3a22760efdf9",
                    accessibleLabel: "Play Kobe Sanders' fourth-quarter three"
                }
            }
        },
        {
            id: "wagler-keeps-coming",
            revealAtMs: 148_400,
            kind: "moment",
            evidenceIds: ["wagler-and-one"],
            presentation: {
                label: "Fight to finish",
                eyebrow: "6:35 · 4th",
                headline: "Wagler fights through the deficit",
                body: "The floater and free throw take him to 11. The result is slipping away, but the Clippers keep attacking the rim.",
                accent: "#C8102E",
                storyteller: {
                    type: "clip",
                    clipId: "a72bb0f1-0b15-85b4-2f20-3a22761328db",
                    accessibleLabel: "Play Keaton Wagler's fourth-quarter and-one"
                }
            }
        },
        {
            id: "manon-and-one",
            revealAtMs: 158_160,
            kind: "insight",
            evidenceIds: ["manon-seventeen"],
            presentation: {
                label: "Player watch",
                eyebrow: "4:33 · 4th",
                headline: "Mañon completes the all-around night",
                body: "The and-one takes him to 17. Add 11 rebounds—four on the offensive glass—two assists and two steals: he set the game in motion, then kept touching every part of it.",
                image: "/media/summer-league/chris-manon-jump-shot.jpg",
                imageAlt: "Chris Mañon shoots over a Clippers defender.",
                accent: "#FDB927",
                stats: [
                    { value: "17", label: "PTS" },
                    { value: "11", label: "REB" },
                    { value: "2", label: "STL" }
                ]
            }
        },
        {
            id: "thiero-rim-run",
            revealAtMs: 163_360,
            kind: "highlight",
            evidenceIds: ["thiero-dunk"],
            presentation: {
                label: "At the rim",
                eyebrow: "3:28 · 4th",
                headline: "Thiero clears the runway",
                body: "One hard drive and a forceful finish keep the Lakers comfortably clear in the closing minutes.",
                accent: "#FDB927",
                storyteller: {
                    type: "clip",
                    clipId: "cc0fca48-5240-c442-1b94-3a22761e2601",
                    poster: "https://storyteller-assets.nba.com/assets/clips/cc0fca48-5240-c442-1b94-3a22761e2601/1242e931-5608-9d3d-b0c0-3a22761e2c48/BestThumbnail.webp",
                    accessibleLabel: "Play Adou Thiero's fourth-quarter dunk"
                }
            }
        },
        {
            id: "summer-final-social",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["final"],
            presentation: {
                label: "From the Lakers",
                eyebrow: "Final · Lakers 99–85",
                headline: "Three games, three Vegas wins",
                body: "The Lakers finish a 99–85 win with a 3–0 Summer League record and five players in double figures.",
                image: "/media/social/x/2077244705696542852.jpg",
                imageAlt: "The Lakers' official social graphic celebrating a 3–0 Summer League start.",
                mediaShape: "portrait",
                source: summerSources.finalX,
                accent: "#FDB927",
                stats: [
                    { value: "99–85", label: "FINAL" },
                    { value: "3–0", label: "VEGAS" },
                    { value: "13", label: "LAL 3PM" }
                ]
            }
        },
        {
            id: "summer-closing-lineup",
            revealAtMs: 180_000,
            kind: "insight",
            evidenceIds: ["final"],
            presentation: {
                label: "Winning support",
                eyebrow: "Final · Kaluma + closing five",
                headline: "Kaluma makes every minute count",
                body: "Fifteen points on 4-of-7 shooting, four assists and a game-best plus-27. Kaluma then anchored a five-player stint that scored 23 points on 8-of-10 shooting.",
                accent: "#FDB927",
                visual: nbaVisualFixtures.summerClosingFive,
                stats: [
                    { value: "15", label: "PTS" },
                    { value: "4 / 7", label: "FG" },
                    { value: "+27", label: "PLUS / MINUS" }
                ]
            }
        },
        {
            id: "carr-final-three",
            revealAtMs: 180_000,
            kind: "moment",
            evidenceIds: ["carr-twenty-three", "final"],
            presentation: {
                label: "Game high",
                eyebrow: "1:10 · 4th",
                headline: "Carr owns the game-high 23",
                body: "His final three supplies the closing flourish to the best scoring night of the game.",
                image: "/media/getty/1522600045/2285558695.jpg",
                imageAlt: "Cameron Carr smiles after his game-high 23-point performance against the Clippers.",
                mediaShape: "portrait",
                source: summerSources.carr,
                accent: "#FDB927",
                stats: [
                    { value: "23", label: "PTS" },
                    { value: "3", label: "3PM" },
                    { value: "+18", label: "MARGIN" }
                ]
            }
        },
        {
            id: "summer-photo-story",
            revealAtMs: 180_000,
            kind: "gallery",
            evidenceIds: ["final"],
            presentation: {
                label: "Photo story",
                eyebrow: "Final · 2 frames",
                headline: "The night in two frames",
                body: "Mañon's shot-making and Kaluma's jumper frame a balanced Lakers win in Las Vegas.",
                accent: "#FDB927",
                gallery: [
                    {
                        image: "/media/getty/1522600045/2285558725.jpg",
                        alt: "Chris Mañon rises for a jump shot against the Clippers.",
                        source: summerSources.manon
                    },
                    {
                        image: "/media/getty/1522600045/2285556968.jpg",
                        alt: "Arthur Kaluma shoots over the Clippers defense in Las Vegas.",
                        source: summerSources.kaluma
                    }
                ]
            }
        },
        {
            id: "final-recap",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["final"],
            presentation: {
                label: "Final",
                eyebrow: "Lakers 99 · Clippers 85",
                headline: "Mañon sets the grammar",
                body: "Mañon's 17 points, 11 rebounds and two steals shaped the complete win; Carr's game-high 23 supplied its scoring peak. Kaluma added 15 and a game-best plus-27, while Kobe Sanders' 18 points and six rebounds led the Clippers' resistance.",
                storyteller: {
                    type: "story",
                    storyId: "8262be30-b4a0-ef94-a0f4-3a2271c0a935",
                    poster: "https://storyteller-assets.nba.com/assets/studio-templates/8262be30-b4a0-ef94-a0f4-3a2271c0a935/4adb4c15-27ac-4fcf-be1d-b02836adc4b0/b8685534-264e-1698-2e61-3a2271c0e81c/thumbnail_small.jpeg",
                    pageCount: 31,
                    actionLabel: "Watch the game story",
                    accessibleLabel: "Open the 31-frame Clippers versus Lakers game story"
                },
                stats: [
                    { value: "17 / 11", label: "MAÑON" },
                    { value: "23", label: "CARR · GAME HIGH" },
                    { value: "+27", label: "KALUMA" }
                ]
            }
        },
        {
            id: "summer-fourth-quarter-score",
            revealAtMs: 180_000,
            kind: "insight",
            evidenceIds: ["summer-end-fourth"],
            presentation: {
                label: "End of 4th",
                eyebrow: "Lakers 99 · Clippers 85",
                headline: "The horn confirms three quarters of control",
                body: "The Clippers win the fourth 25–16, but the Lakers' earlier control holds: five scorers in double figures and a third straight win in Las Vegas.",
                accent: "#FDB927",
                stats: [
                    { value: "16–25", label: "4TH QUARTER" },
                    { value: "+14", label: "FINAL MARGIN" },
                    { value: "3–0", label: "LAS VEGAS" }
                ]
            }
        }
    ]
};
